const AddHuman = () => import(/* webpackPrefetch: true, webpackChunkName: "add-human" */ '@/app/views/auth-view/components/auth-register/components/add-human/add-human.vue');

export default {
    name: 'AuthRegisterContainer',
    components: {
        AddHuman
    }
}